module.exports = __webpack_public_path__ + "static/media/popup6-min.c140d5e5.png";